import React, { Fragment, useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import clsx from 'clsx';
import {
  Box,
  Button,
  Card,
  Divider,
  Grid,
  makeStyles,
  Paper,
  TextField,
  Typography
} from '@material-ui/core';
import Header from '../headers/Header';
import Footer from '../footer/Footer';

import 'react-toastify/dist/ReactToastify.css';

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    minHeight: '100%',
    marginTop: '0px'
  },
  root: {
    margin: '20px 30px',
    marginBottom: '50px',
    padding: '20px 20px'
  },
  mainTable: {
    margin: '20px 0 20px'
  },
  title: {
    color: 'var(--gmi-color)',
    textAlign: 'center',
    marginBottom: '50px'
  },
  divider: {
    backgroundColor: 'var(--gmi-color)',
    height: '5px',
    margin: '10px 0'
  },
  editForm: {
    display: 'grid',
    padding: '2% 5%'
  },
  inputField: {
    margin: '10px 0'
  },
  inputCont: {
    [theme.breakpoints.down('xs')]: {
      display: 'block'
    }
  },
  btnContainer: {
    textAlign: 'right',
    marginBottom: '5px',
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'space-evenly'
    }
  },
  button: {
    background: 'var(--gmi-color)',
    color: 'white',
    marginLeft: '30px',
    width: '100px',
    "&:hover": {
      backgroundColor: '#113e78ec'
    },
    [theme.breakpoints.down('xs')]: {
      margin: '5px 0'
    }
  },
  snackbarSuccess: {
    backgroundColor: 'red !important',
    fontSize: '1em'
  }
}));

// const fakeDataConsole =
//   {
//     uuid: '24654e-fsdf684-dsfs784',
//     console_id: 'A40-002',
//     console_nickname: 'MOS TEST 1',
//     console_type: 'V 2.0',
//     console_calibdate: '2020-04-12'
//   };

const AdminConsolesEdit = ({ className, ...rest }) => {
  const classes = useStyles();
  const [consoleData, setConsoleData] = useState({
    uuid: "",
    console_id: "",
    console_nickname: "",
    console_type: "",
    console_calibdate: "",
  });
  const [updatedData, setUpdatedData] = useState({
    uuid: "",
    console_id: "",
    console_nickname: "",
    console_type: "",
    console_calibdate: "",
  });
  const [saved, setSaved] = useState(false);
  const { uuid } = useParams();
  const history = useHistory();

  // console.log('consoleData :', consoleData);
  // console.log('UPDATEDData :', updatedData);

  const handleUpdateData = (e) => {
    setUpdatedData({
      ...updatedData,
      [e.target.id]: e.target.value
    });
  };

  // const handleUpdateCalibdate = (e) => {
  //   setUpdatedData({...updatedData, console_calibdate: new Date([e.target.value]).toISOString()});
  // };
  
  useEffect(() => {
    const getConsoleData = async () => {
      const result = await axios.get(`http://cloud.gmi-aero.com:5000/console/${uuid}`);
      setConsoleData(result.data[0]);
      setUpdatedData(result.data[0]);
    };
    getConsoleData();
  }, [uuid]);

  const updateConsoleData = async (e) => {
    const url = `http://cloud.gmi-aero.com:5000/console/${uuid}`;
    // const body = {
    //   ...updatedData,
    //   console_calibdate: updatedData.console_calibdate.toString().concat("T23:59:00.000Z")
    // };
    try {
      await axios
        .put(url, updatedData)
        .then(res => console.log(res));
        toasterSucc();
        setSaved(true);
    } catch (err) {
      err && toasterErr(err);
    }
  };
  
  const toasterSucc = () => {
    return (
      toast.success('Console successfully edited!', {
        position: "bottom-center",
        autoClose: 4000,
        onClose: () => history.push('/admin/consoles'),
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      })
    );
  };

  const toasterErr = (error) => {
    return (
      toast.error(`${error}`, {
        position: "bottom-center",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
      })
    );
  };

  return (
    consoleData ? (
      <Fragment>
        <Header type={"admin"} />
        <div className={clsx(classes.pageContainer, className)}>
          <Card
            className={clsx(classes.root, className)}
            elevation={2}
            {...rest}
          >
            <Typography
              className={classes.title}
              gutterBottom
              variant="h4"
            >
              CONSOLE EDIT
            </Typography>
            <Divider className={classes.divider}/>

            <Grid>
              <Paper className={classes.mainTable}>
                <form className={classes.editForm} autoComplete="off">
                  <TextField
                    className={classes.inputField}
                    label="UUID"
                    id="console-uuid"
                    value={consoleData.uuid}
                    variant="outlined"
                    readOnly
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TextField
                    className={classes.inputField}
                    label="End user ID"
                    id="console_nickname"
                    value={updatedData.console_nickname}
                    onChange={handleUpdateData}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <TextField
                    className={classes.inputField}
                    label="Console S/N"
                    id="console_id"
                    value={updatedData.console_id}
                    onChange={handleUpdateData}
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  <Grid
                    className={classes.inputCont}
                    container
                    justify="space-between"    
                  >
                    <Box flex = {1} mr = {{ xs: 0, sm: '0.5em' }} >
                      <TextField
                        className={classes.inputField}
                        label="Console type"
                        id="console_type"
                        value={updatedData.console_type}
                        onChange={handleUpdateData}
                        variant="outlined"
                        fullWidth
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Box>
                    <Box flex = {1} ml = {{ xs: 0, sm: '0.5em' }} >
                      <TextField
                        className={classes.inputField}
                        id="console_calibdate"
                        label="Calibration date"
                        type="date"
                        value={updatedData.console_calibdate}
                        
                        onChange={handleUpdateData}
                        // onChange={handleUpdateCalibdate}
                        
                        variant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        fullWidth
                      />
                    </Box>
                  </Grid>
                </form>
              </Paper>
            </Grid>

            <div className={classes.btnContainer}>
              {
                ((consoleData === updatedData) || saved )
                ? <Button className={classes.button} href="/admin/consoles">&lt; Back</Button>
                : <Button className={classes.button} href="/admin/consoles">Cancel</Button>
              }
              <Button className={classes.button} onClick={updateConsoleData}>Save</Button>
              <ToastContainer />
            </div>
          </Card>
        </div>
        <Footer type="main"/>
      </Fragment>
    )
    : null
  )
};

export default AdminConsolesEdit;
